//here will be created table with viewed elements
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress,
    Tooltip,
    Box,
    Chip,
    TextareaAutosize,
    IconButton,
    InputAdornment,
    TextField,
} from '@mui/material';
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import {AgyleNamedIcon} from "../../../components/icons/agyle";
import * as React from "react";
import {Table} from 'react-infinite-table';
import {forEach} from "lodash";
import moment from "moment";
import clsx from  'clsx';
import _ from "lodash";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DataObjectIcon from '@mui/icons-material/DataObject';
import DataArrayIcon from '@mui/icons-material/DataArray';
import {setSnackbar} from "../../../store/reducers/globals";
import {useDispatch} from "react-redux";
import {
    DictionaryMissingElementTableRenderer,
    DictionaryMissingElementTypes,
    getStringValue,
    prepareDictArrayNames,
} from './admin_dictionaries_helpers';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AgyleDialog from "../../../components/modal/agyleDialog";
import {
    ClickAwayListener,
    MenuItem,
} from '@material-ui/core';
import Popper from '@mui/material/Popper';
import Grid from '@mui/material/Grid';
import {getConsultantName, getConsultantCode} from "../../../controls/agyle/clinitian";
import AgyleAccordion from '../../../components/ui/accordion/agyleAccordion';
import _cloneDeep from 'lodash/cloneDeep';
import AgyleCheckBox from '../../../components/ui/checkbox/agyleCheckBox';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AgyleSwitch from '../../../components/ui/switch/agyleSwitch';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import Autocomplete from '@mui/lab/Autocomplete';
import MessageBox from '../../../util/messageBox';
import {AdminAPI} from "../admin_api";
import AgyleLoadingSpinner from '../../../components/other/agyleLoadingSpinner';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import {useWebSocket} from '../../../context/WebSocketProvider';
import {useEffect} from 'react';

const useStyles = makeStyles((theme) => ({
    empty: {
        height: "0px !important"
    },
    dictRepresentation: {
        border: "1px solid #004887e8",
        padding: "7px 14px",
        display: "inline",
        borderRadius: "10px",
        background: "#0048872e"
    },
    actionBtn: {
        width: "24px",
        height: "24px",
        padding: "1px",
        minWidth: "24px",
        border: "1px solid rgba(255, 255, 255, 0.25)",
        boxShadow: "1px 1px 3px -1px #bbbbbb"
    },
    btnConfigFields: {
        marginRight: "4px",
        width: "40px",
        height: "40px"
    },
    edit: {
        color: "#448FFF",
        // marginRight: "10px",
        "&:hover": {
            border: "2px solid #448FFF",
            boxShadow: "1px 1px 3px -1px #448FFF",
        },
    },
    delete: {
        color: "#FF6868",
        "&:hover": {
            border: "2px solid #FF6868",
            boxShadow: "1px 1px 3px -1px #FF6868",
        }
    },
    viewJson: {
        color: "#85cb29",
        "&:hover": {
            border: "2px solid #beff68",
            boxShadow: "1px 1px 3px -1px #85cb29",
        }
    },
    info: {
        color: "#FEB03A",
        "&:hover": {
            border: "2px solid #FEB03A",
            boxShadow: "1px 1px 3px -1px #FEB03A",
        }
    },
    merge: {
        color: "#b529cb",
        "&:hover": {
            border: "2px solid #c03ad5",
            boxShadow: "1px 1px 3px -1px #c03ad5",
        }
    },
    dictTable: {
        width: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "row",
        background: "transparent",
        overflowWrap: "break-word",
        "& .react-infinite-table-wrapper": {
            maxHeight: "100%",
            maxWidth: "100%",
            width: "100%",
            boxSizing: "border-box",
            zIndex: "1",
            "-webkit-overflow-scrolling": "touch",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "8px",
                height: "8px",
                borderRadius: "10px",
                backgroundColor: "transparent",
                "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.75)"
                },
                "&:active": {
                    backgroundColor: "rgba(255, 255, 255, 0.75)"
                }
            },
            "&::-webkit-scrollbar-track": {
                "-webkit-box-shadow": "none"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(128, 128, 128, 0.41)",
                borderRadius: "10px",
                "&:hover": {
                    backgroundColor: "gray"
                },
                "&:active": {
                    backgroundColor: "gray"
                }
            },
            "& table": {
                width: "100%",
            }
        },

        "& .react-infinite-table-scroll-smoother": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 5,
            pointerEvents: "none"
            // will-change: transform;
        },

        "& .react-infinite-prevent-table-fill": {
            flexGrow: 1
        },

        "& table": {
            borderSpacing: 0,
            borderCollapse: "separate",
            tableLayout: "fixed",
            boxSizing: "border-box",
            //minHeight: "100%",
            margin: "0px",
            maxWidth: "100%",
            width: "auto"
        },

        "&.react-infinite-table-fill": {
            "& table": {
                width: "100%"
            },
            "& .react-infinite-table-wrapper": {
                width: "100%"
            },
            "& .react-infinite-prevent-table-fill": {
                flexGrow: 0
            }
        },

        "& td": {
            boxSizing: "border-box",
            background: "transparent",

            "&.is-fixed-left": {
                position: "sticky",
                left: 0
            },
            height: 70
        },

        "& th": {
            boxSizing: "border-box",
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            zIndex: 2,
            textAlign: "left",
            height: 36,
            paddingLeft: "10px"
        },

        "& td.is-fixed-left": {
            zIndex: 3
        },

        "& th.is-fixed-left": {
            zIndex: 4
        },

        "& th.is-sortable": {
            cursor: "pointer"
        },

        "& thead": {
            boxSizing: "border-box",

            "& th, td": {
                position: "sticky",
                top: 0,
                zIndex: 2
            }
        },

        "& tbody": {
            boxSizing: "border-box"
        },

        "& tfoot": {
            boxSizing: "border-box",
            position: "sticky",
            bottom: 0,
            zIndex: 3,

            "& th, td": {
                position: "sticky",
                bottom: 0,
                zIndex: 3,

                "&.is-fixed-left": {
                    zIndex: 4
                }
            }
        },

        "& th, td": {
            "&.react-infinite-column-dragging": {
                zIndex: 6
            },

            "&.react-infinite-column-resize::after": {
                content: '',
                position: "absolute",
                right: "0px",
                top: "0px",
                bottom: "0px",
                marginRight: "-2px",
                width: "4px",
                cursor: "col-resize"
            }
        },

        "& tr.react-infinite-table-loading-no-rows": {
            height: "fit-content",

            "& td": {
                verticalAlign: "unset",
                "&> div": {
                    position: "sticky",
                    left: "1px",
                    width: "fit-content"
                }
            }
        },

        "& tr.react-infinite-table-spacer": {
            "& td": {
                border: "none",
                padding: "0px",
                margin: "0px"
            }
        },

        "&.react-infinite-table-fix-borders": {
            "& table": {
                "& thead, tbody, tfoot": {
                    "& td, th": {
                        borderLeft: "none",

                        "&:last-child": {
                            borderRight: "none"
                        }
                    }
                },

                "& thead, tbody": {
                    "& td, th": {
                        borderTop: "none"
                    }
                },

                "& tfoot td": {
                    borderBottom: "none"
                }
            }
        },

        "& tr.tr-odd": {
            background: "#ffffff2e",
            height: "fit-content !important",
        }
    },
    dictTableTh: {
        position: "sticky"
    },
    actionsCol: {
        width: "140px"
    },
    actionsColMerge: {
        width: "190px"
    },
    actionsColRecord: {
        textAlign: "center"
    },
    actionsColBtn: {
        float: "right",
        color: "rgba(255, 255, 255, 0.75)",
        marginRight: "10px",
        border: 0,
        "&:hover": {
            border: 0,
            color: theme.palette.primary.contrastText,
        },
        "& svg": {
            width: "28px",
            height: "28px",
        }
    },
    icon: {},
    check: {
        color: "#2bc12b"
    },
    cancel: {
        color: "#FF6868"
    },
    oidIcon: {
        "& svg": {
            color: theme.palette.primary.main,
        }
    },
    objectIcon: {
        "& svg": {
            color: "#f7bf57",
        }
    },
    colBoolean: {
        paddingLeft: "0px !important",
        width: "100px",
        maxWidth: "100px",
        minWidth: "100px",
        textAlign: "center !important"

    },
    colorPickerDisplay: {
        marginLeft: "10px",
        display: "inline-block",
        width: "40px",
        height: "24px",
        border: "2px solid silver",
        borderRadius: "10px"
    },
    moreActionPopper: {
        zIndex: 100,
    },
    moreActionsBox: {
        transform: "translateX(40px)",
        background: "transparent",
        "& ul": {
            paddingInlineStart: 0,
            backgroundColor: theme.palette.mode === 'light' ? '#e3e3e3' : '#434343',
            boxShadow: theme.palette.mode === 'light' ? '5px 4px 14px #434343' : '5px 4px 14px #232323',
            borderRadius: "5px",
            margin: "1px 5px"
        },
        "& li": {
            padding: "3px 5px 2px 5px",
            listStyleType: "none",
            "& div": {
                display: "inline-flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "stretch",
                justifyContent: "flex-start",
                width: "100%",
                cursor: "pointer",
                padding: "3px",
                borderRadius: "5px",
                "& svg": {
                    marginRight: "5px"
                },
                "&:hover": {
                    backgroundColor: theme.palette.mode === 'light' ? '#eFeFeF' : '#4F4F4F',
                }
            }
        }

    },
    uppercase: {
        textTransform: "uppercase"
    },
    consultantName: {
        padding: "0px 10px 14px 14px",
        fontSize: "18px",
        fontWeight: 600

    },
    sideBySidePanel: {
        display: "inline-flex",
        justifyContent: "space-evenly",
        alignItems: "stretch",
        width: "100%"
    },
    consultantPanel: {
        width: "calc(50% - 40px)",
        maxHeight: "calc(65vh - 140px)",
        minHeight: "200px",
        overflow: "auto",
        border: "1px solid silver",
        borderRadius: "3px",
        padding: "6px 10px",
        cursor: "pointer"
    },
    unusedConsultants: {
        marginRight: "10px"
    },
    toolPanel: {
        width: "46px",
        padding: "2px",
        maxHeight: "calc(65vh - 140px)"
    },
    button: {
        padding: 0,
        margin: "0 4px 10px 4px",
        lineHeight: "10px",
        minWidth: "36px",
        height: "34px"
    },
    usedConsultants: {
        marginLeft: "10px"
    },
    pickedToMove: {
        background: "yellowgreen"
    },
    consultantItem: {
        padding: "2px 5px 0px",
        margin: "0px 0px 3px",
        borderRadius: "3px",
        border: "0.5px solid transparent",
        '&:hover': {
            borderColor: "rgb(215, 215, 215)"
        }
    },
    optionLine: {
        padding: "0px 15px 8px",
        cursor: "pointer",
        "&:last": {
            paddingBottom: 0,
        }
    },
    optionSquareMarker: {
        width: "14px",
        height: "18px",
        borderRadius: "3px",
        border: "0.5px solid silver",
        display: "inline-block",
        marginRight: "5px",
        marginBottom: "3px",
        "&.small": {
            width: "9px",
            height: "16px",
            marginLeft: "8px",
            marginBottom: "1px",
            marginRight: "-8px",
        }
    },
    roleChip: {
        border: "1px solid #7d7d7d",
        borderRadius: "10px",
        height: "26px",
        marginLeft: "5px"
    },
    squareMarker: {
        width: "10px",
        minWidth: "10px",
        height: "18px",
        borderRadius: "3px",
        border: "0.5px solid silver",
        cursor: "help",
        display: "inline-block",
        marginRight: "5px",
        marginBottom: "-4px"
    },
    optionDescription: {
        display: "inline-block",
    },
    pickerDesc: {
        display: "inline-flex",
        alignItems: "center",
        marginLeft: 5,
        marginTop: "-8px",
        marginBottom: "5px"
    },
    pickerSpec: {
        padding: "7px 7px 3px 6px",
        marginLeft: "7px"
    },
    filterSection: {
        display: "inline-flex",
        justifyContent: "space-between",
        alignContent: "center",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
        width: "calc(100% - 10px)",
        marginBottom: "15px",
        marginLeft: "3px",
        marginRight: "0px",
    },
    filterGroup: {
        display: "inline-flex",
        alignItems: "center",
        marginTop: 8,
        maxWidth: "calc(100% - 162px)"
    },
    keepSelected: {
        width: 162
    },
    filterItem: {
        marginRight: "8px",
        minWidth: "250px",
    },
    inputFilter: {
        "& input":{
            padding: "7.5px 9px",
            "&:-webkit-autofill, :-webkit-autofill:focus" : {
                transition: "background-color 600000s 0s, color 600000s 0s",
                boxShadow: "unset"
            }
        }
    },
    buttonFilter: {
        width: "50px",
        border: "1px solid silver",
        padding: "3px 12px",
        borderRadius: "10px"
    },
    rolesSelectField: {
        "& .MuiOutlinedInput-root": {
            padding: 0
        },
        "& label": {
            lineHeight: "1rem",
            top: "-3px",
            "&.MuiInputLabel-shrink": {
                top: 0
            }
        }
    }
}));

export function DictionariesAdminTable(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const {manageSubscription, message} = useWebSocket();

    const [fields, setFields] = React.useState([]);
    const [columns, setColumns] = React.useState([]);
    const [fieldsData, setFieldsData] = React.useState([]);
    const [orderColumnsOpen, setOrderColumnsOpen] = React.useState(false);
    const [viewRowItemOpen, setViewRowItemOpen] = React.useState(false);
    const [viewConsultantAvailableInPickerOpen, setViewConsultantAvailableInPickerOpen] = React.useState(false);
    const [viewManageAvailableInPickersOpen, setManageAvailableInPickersOpen] = React.useState(false);
    const [viewRowItem, setViewRowItem] = React.useState(null);
    const dataSliceLength = 200;
    const defDateFormat = "YYYY-MM-DD HH:mm:ss";
    const [infinityLoading, setInfinityLoading] = React.useState(false);
    const [infinityScrollEdge, setInfinityScrollEdge] = React.useState(500);
    //const [additionalDicts, setAdditionalDicts] = React.useState({});
    const [editObjectJson, setEditObjectJson] = React.useState();
    const [idsBlockedForEdit, setIdsBlockedForEdit] = React.useState([]);
    const [webSocketChanel, setWebSocketChanel] = React.useState(props.webSocketChanel);
    const [runSocket, setRunSocket] = React.useState(true);
    const [expanded, setExpanded] = React.useState({});
    const [rerender, setRerender] = React.useState(false);
    const [rowAnchorEl, setRowAnchorEl] = React.useState(null);
    const [rowAffectedMenu, setRowAffectedMenu] = React.useState(null);
    const [availableModules] = React.useState( () => {
        let am = [];
        _.forEach(props.activeModules, acm => {
            if(acm.enabled) am.push(acm.id);
        })
        return am;
    })
    const openRowActionMenu = Boolean(rowAnchorEl);
    const [dividedGroup, setDividedGroup] = React.useState([]);
    const handleClickRowActionMenu = (event, rowAffected) => {
        setRowAnchorEl(event.currentTarget);
        setRowAffectedMenu(rowAffected);
        event.stopPropagation();
        event.preventDefault();
    };
    const handleCloseActionMenu = (event) => {
        setRowAnchorEl(null);
        setRowAffectedMenu(null);
        event.stopPropagation();
        event.preventDefault();
    };
    const [confirmDialog, setConfirmDialog] = React.useState(false);
    const [pickedToMove, setPickedToMove] = React.useState({off: [],on: []});
    const [allConsultants, setAllConsultants] = React.useState([]);
    const [filterConsultant, setFilterConsultant] = React.useState({
        text: "",
        roles: [],
        rolesIds: [],
        rolesDictItemsAll: [],
        rolesDictItems: [],
        rolesColorIconMap: {},
        consultantsActive: [],
        consultantsNotActive:[],
        moveAllOperationSide: null,
        confirmMessage: {
            allToOff: "remove access to",
            allToOn: "add access to"
        },
        isFiltering: false,
        keepSelected: false,
    });
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        manageSubscription([props.webSocketChanel], runSocket);
    }, [runSocket]);

    const rolesSelected = (selectedItem) => {
        if(selectedItem) {
            const sItems = [...filterConsultant.roles, selectedItem]
            let fc = _.cloneDeep(filterConsultant);
            fc.roles = sItems;
            fc.rolesIds = sItems.map(si => si._id);
            _.remove(fc.rolesDictItems, (item) => fc.rolesIds.indexOf(item._id) > -1);
            setFilterConsultant(fc);
        }
    }

    const rolesUnselected = (removedItemName, ev) => {
        let j = 0;
            let fc = _.cloneDeep(filterConsultant);
        for (let i = 0; i < fc.rolesDictItemsAll.length; i++) {
            if (fc.rolesDictItemsAll[i]._id == removedItemName._id) {
                if(_.findIndex(fc.rolesDictItems, (rdi) => {
                    return rdi._id == fc.rolesDictItemsAll[i]._id;
                }) == -1) fc.rolesDictItems.splice(j, 0, _.cloneDeep(fc.rolesDictItemsAll[i]));
                if(fc.rolesIds.indexOf(fc.rolesDictItemsAll[i]._id) > -1)
                    fc.rolesIds.splice(fc.rolesIds.indexOf(fc.rolesDictItemsAll[i]._id), 1);
                i = fc.rolesDictItemsAll.length; //finish
            } else {
                if (_.findIndex(fc.rolesDictItems, (rdi) => {
                    return rdi._id == fc.rolesDictItemsAll[i]._id;
                }) > -1) {
                    j++
                }
            }
        }
        _.remove(fc.roles, itm => itm._id == removedItemName._id);
        setFilterConsultant(fc);
    }

    const textFilterChange = (text) => {
        let fc = _.cloneDeep(filterConsultant);
        fc.text = text;
        setFilterConsultant(fc);
    }

    const renderCustomOption = (item) => {
        return <MenuItem key={item.__id} value={item} onClick={()=>{rolesSelected(item)}}>
            <div className={classes.optionSquareMarker} style={{background : item.color || "#c0c0c03d"}}></div>
            <div className={classes.optionDescription}>{item.description}</div>
        </MenuItem>
    }

    const renderValue = (value) => {
        let rv = [];
        if(value && Array.isArray(value)){
            rv = value.map(v => <Chip key={v._id} label={v.description} className={classes.roleChip} variant="outlined"
                                      avatar={<div className={clsx([classes.optionSquareMarker, 'small'])}
                                                   style={{background : v.color || "#c0c0c03d"}}></div>}
                                      onDelete={(ev) => {
                                          rolesUnselected(v, ev);
                                          ev.preventDefault()
                                      }}
                                      />);
        }
        return rv
    }

    const keepSelectedChange = (ev) => {
        if (!filterConsultant.isFiltering) {
            let fc = _.cloneDeep(filterConsultant);
            fc.keepSelected = ev.target.checked;
            setFilterConsultant(fc);
        }
    }

    const pickToMove = (consultantId, side) => {
        let ptm = _.cloneDeep(pickedToMove);
        let itemIdx = ptm[side].indexOf(consultantId);
        if(itemIdx == -1) {
            ptm[side].push(consultantId);
        } else {
            ptm[side].splice(itemIdx, 1);
        }
        setPickedToMove(ptm);
    }

    const confirmMoveAll = (side) => {
        let fc = _.cloneDeep(filterConsultant);
        fc.moveAllOperationSide = side;
        setFilterConsultant(fc);
        setConfirmDialog(true);
    }

    const moveAllToOtherSideAgree = () => {
        const [direction, setName] =  filterConsultant.moveAllOperationSide == "allToOn" ? [1, "consultantsNotActive"] : [-1, "consultantsActive"];
        updateSetOfConsultants(filterConsultant[setName], direction);
    }

    const moveToOtherSide = (direction) => {
        const [setName, pickedSetName] = direction == 1 ? ["consultantsNotActive", "on"] : ["consultantsActive", "off"] ;
        updateSetOfConsultants(_.filter(filterConsultant[setName], (c) => pickedToMove[pickedSetName].indexOf(c._id) > -1), direction);
    }

    const updateSetOfConsultants = (consultantsSet, direction) => {
        //move upper if there will be a race abd updates if additional dict has to change
        //direction -1/1 : remove / add
        const consultantsSetIds = consultantsSet.map(c => {
            return c._id;
        });
        setLoading(true);
        let updateConsultantsPromises = [];
        let side = {};
        let fc = _.cloneDeep(filterConsultant);
        //viewRowItem
        consultantsSet.forEach((consultantToUpdate) => {
            if(direction > 0 && consultantToUpdate.availableIn.indexOf(viewRowItem._id) < 0) {
                consultantToUpdate.availableIn.push(viewRowItem._id);
                side = {from: "consultantsNotActive", to: "consultantsActive"};
            }
            if(direction < 0 && consultantToUpdate.availableIn.indexOf(viewRowItem._id) >= 0) {
                consultantToUpdate.availableIn.splice(consultantToUpdate.availableIn.indexOf(viewRowItem._id), 1);
                side = {from: "consultantsActive", to: "consultantsNotActive"};
            }
            let cToSave = _.cloneDeep(consultantToUpdate);
            delete cToSave.mapRoles;
            updateConsultantsPromises.push(AdminAPI.saveTableRecord('consultants', cToSave));
        });
        Promise.all(updateConsultantsPromises).then((resArr) => {
            _.remove(fc[side.from], (cls) => consultantsSetIds.indexOf(cls.id) >= 0);
            fc[side.to].push(...consultantsSet);
            setFilterConsultant(fc);
            setPickedToMove({off: [],on: []});
            setLoading(false);
            let allConsultantsTmp = _.cloneDeep(allConsultants);
            resArr.forEach(changedConsultant => {
                let clTmp = _.find(allConsultantsTmp, (cl) => cl._id == changedConsultant._id);
                if(clTmp) clTmp.availableIn = _.cloneDeep(changedConsultant.availableIn);
                else {
                    console.log("that should never happen!!!!");
                    allConsultantsTmp.push(changedConsultant);

                }
            })
            setAllConsultants(allConsultantsTmp);
            props.rowAction("updateConsultants", viewRowItem, null, consultantsSet);
        }, error => {
            console.log("error", error);
        });
    }

    const filterConsultants = () => {
        let fc = _.cloneDeep(filterConsultant);
        fc.isFiltering = true;
        setTimeout(()=>{
            return new Promise(()=>{
                //clear
                fc.consultantsActive.splice(0, fc.consultantsActive.length);
                fc.consultantsNotActive.splice(0, fc.consultantsNotActive.length);
                if(fc.text == "" && fc.roles.length == 0){  // filterText, filterRoles, move outside!!!!
                    let consultantsArr = _separateConsultantsActiveNonActive(allConsultants, viewRowItem);
                    fc.consultantsActive = consultantsArr[0];
                    fc.consultantsNotActive = consultantsArr[1];
                    fc.isFiltering = false;
                    setFilterConsultant(fc);
                } else {
                    setLoading(true);
                    coreFilterConsultants(fc.text, fc.rolesIds, allConsultants, props.filterHelper).then((filteredIds)=>{
                        if(!fc.keepSelected) {
                            pickedToMove.off = _.intersection(pickedToMove.off, filteredIds);
                            pickedToMove.on = _.intersection(pickedToMove.on, filteredIds);;
                        }
                        const unionFiltered = _.union(filteredIds, pickedToMove.off, pickedToMove.on);
                        let consultantsArr = _separateConsultantsActiveNonActive(_.filter(allConsultants, (c) => unionFiltered.indexOf(c._id) > -1), viewRowItem);
                        fc.consultantsActive = consultantsArr[0];
                        fc.consultantsNotActive = consultantsArr[1];
                        fc.isFiltering = false;
                        setLoading(false);
                        setFilterConsultant(fc);
                    });
                }
            })
        }, 1);
    }

    const coreFilterConsultants = (filterText, filterRolesIDs, dictionaryConsultant, filterHelper) => {
        return new Promise((resolve) => {
            let idsByText = [];
            let idsByRoles = [];
            let useRoles = false;
            let useText = false;
            //roles
            if(filterRolesIDs && Array.isArray(filterRolesIDs) && filterRolesIDs.length > 0){
                let c = _.filter(dictionaryConsultant, (consultant) => {
                    if(filterHelper.hasOwnProperty("rolesFilter")){
                        let consultantRoles = [];
                        filterHelper.rolesFilter.forEach(roleFilterField => {
                            let consultantRoleFilterValue = _.get(consultant, roleFilterField, []);
                            if(!Array.isArray(consultantRoleFilterValue)) consultantRoleFilterValue = [consultantRoleFilterValue];
                            consultantRoles = _.union(consultantRoles, consultantRoleFilterValue);
                        })
                        return (_.intersection(consultantRoles, filterRolesIDs)).length > 0
                    }
                    return false;
                });
                idsByRoles = _.map(c, (cl) => {
                    return cl._id
                })
                useRoles = true;
            }
            //free text
            if(filterText && filterText.length > 0){
                let inputTextConditionArray = [];
                if(filterText != null) {
                    filterText.split(" ").forEach(orCond => {
                        let itemAnd = orCond.split("&");
                        if (Array.isArray(itemAnd)) {
                            inputTextConditionArray.push(itemAnd);
                        } else {
                            inputTextConditionArray.push([itemAnd]);
                        }
                    });
                }
                const getMatchedIds = (andCondition, filterHelper) => {
                    let consultantIds = [];
                    let filtered = _.filter(dictionaryConsultant, (consultant) => { //
                        let result = false;
                        let consultantStr = "";
                        if(filterHelper && filterHelper.hasOwnProperty('textFilter')){
                            filterHelper.textFilter.forEach((fieldKey) => {
                                if(consultantStr.length > 0) consultantStr += "|";
                                consultantStr += _.get(consultant, fieldKey, "");
                            })
                        }
                        for(let i = 0 ; i< andCondition.length; i++){
                            if (!(/[A-Z]/.test(andCondition[i]))) consultantStr = consultantStr.toLowerCase();
                            result = result || consultantStr.match(andCondition[i]) != null;
                        }
                        return result;
                    });
                    consultantIds.push(..._.map(filtered, (c) => {
                        return c._id;
                    }));
                    return consultantIds;
                }
                _.forEach(inputTextConditionArray, (andCondition) => {
                    idsByText.push(...getMatchedIds(andCondition, filterHelper));
                });
                useText = true;
            }
            if(useRoles && useText){
                resolve(_.intersection(idsByRoles, idsByText));
            } else {
                useRoles ? resolve(idsByRoles): resolve(idsByText);
            }
        })
    }

    React.useEffect(()=>{
        if(props.fields && props.fields.length > 0){
            let fieldsColumns = [];
            forEach(props.fields, (field)=>{
                if(!field.hasOwnProperty("moduleAccess") || (field.hasOwnProperty("moduleAccess") && availableModules.indexOf(field.moduleAccess) > -1)){
                    fieldsColumns.push({
                        cellRenderer: ({columnIndex, column, rowData, rowIndex, className}) => {
                            if (rowData.hasOwnProperty("_id") || props.masterRecordId) {
                                let fieldType = field.type ? field.type : "text";
                                switch (fieldType) {
                                    case "readOnly": // not supported as an extra type
                                        return (<td>NOT SUPPORTED 'readOnly' TYPE</td>)
                                    case "text":
                                        if (typeof _.get(rowData, field.id) == 'object' && _.get(rowData, field.id) != null) {
                                            let icon = Array.isArray(rowData[field.id]) ? (<DataArrayIcon/>) : (
                                                <DataObjectIcon/>);
                                            let value;
                                            if (field.id == props.idField && _.get(rowData, field.id).hasOwnProperty("$oid")) {
                                                value = (<Tooltip title={rowData[field.id]["$oid"]}
                                                                  className={classes.oidIcon}>
                                                    <Chip icon={icon} label={rowData[field.id]["$oid"]}
                                                          variant="outlined"
                                                          onClick={() => {
                                                              handleCopyToClipboard(rowData[field.id]["$oid"])
                                                          }}/>
                                                </Tooltip>);

                                            } else {
                                                let itemV;
                                                if (_.get(rowData, field.id).hasOwnProperty("$numberInt")) {
                                                    itemV = rowData[field.id]['$numberInt'].toString();
                                                } else {
                                                    if (_.get(rowData, field.id).hasOwnProperty("$numberDouble")) {
                                                        itemV = rowData[field.id]['$numberDouble'].toString();
                                                    } else {
                                                        itemV = JSON.stringify(_.get(rowData, field.id));
                                                    }
                                                }
                                                if (itemV) {
                                                    itemV = itemV.replaceAll("\"", "");
                                                }
                                                value = (<Tooltip title={itemV} className={classes.objectIcon}>
                                                    <Chip icon={icon}
                                                          label={_.upperCase(field.id)}
                                                          variant="outlined"
                                                          onClick={() => {
                                                              handleCopyToClipboard(itemV)
                                                          }}/>
                                                </Tooltip>);
                                            }
                                            return (
                                                <td>{value}</td>
                                            )
                                        } else {
                                            return (
                                                <td>
                                                    {_.get(rowData, field.id) == null ? "" : _.get(rowData, field.id)}
                                                </td>
                                            )
                                        }
                                    case "number": {
                                        if (_.get(rowData, field.id) && _.get(rowData, field.id).hasOwnProperty("$numberInt")) {
                                            return (<td>
                                                {_.get(rowData, field.id)["$numberInt"] == null ? "" : _.get(rowData, field.id)["$numberInt"]}
                                            </td>)
                                        } else {
                                            return (<td>
                                                {_.get(rowData, field.id) == null ? "" : _.get(rowData, field.id)}
                                            </td>)
                                        }
                                    }
                                    case "date":
                                        let tmpDate;
                                        if (_.get(rowData, field.id) && _.get(rowData, field.id).hasOwnProperty("$date") && _.get(rowData, field.id)["$date"].hasOwnProperty("$numberLong")) {
                                            let dateLong = Number(_.get(rowData, field.id).$date.$numberLong);
                                            tmpDate = field.format ? moment.utc(dateLong).format(field.format) : moment.utc(dateLong).format(defDateFormat)
                                        }
                                        return (
                                            <td>
                                                {tmpDate ? tmpDate : "-"}
                                            </td>
                                        )
                                    case "address":
                                        let rdAddress = _.get(rowData, field.id);
                                        let address = [];
                                        if (rdAddress && rdAddress.hasOwnProperty('type')) {
                                            address.push((<div>({t('type')}) {rdAddress.type}</div>));
                                        }
                                        if (rdAddress && rdAddress.hasOwnProperty('postalCode')) {
                                            address.push((<div>({t('Postal')}) {rdAddress.postalCode}</div>));
                                        }
                                        if (rdAddress && rdAddress.hasOwnProperty('lines')) {
                                            forEach(rdAddress.lines, (line) => {
                                                address.push((<div>{line}</div>));
                                            })
                                        }
                                        return (
                                            <td>
                                                {address}
                                            </td>
                                        )
                                    case "boolean":
                                        let val;
                                        if (_.get(rowData, field.id) != null) {
                                            if (_.get(rowData, field.id)) {
                                                val = (<CheckIcon className={classes.check}/>);
                                            } else {
                                                val = (<CloseIcon className={classes.cancel}/>);
                                            }
                                        }
                                        return (
                                            <td align="center">
                                                {val}
                                            </td>
                                        )
                                    case "dictionary":
                                        //Like search, but using proper $oid to avoid change string value ( like code )
                                        //todo: refactor that two types , small difference between search and dictionary
                                        let nestedId = _.get(rowData, field.id);
                                        if (field.hasOwnProperty('dict')) {
                                            if (nestedId) {
                                                let missingText = t("Incorrect configuration, missing dependency table dictionary!");
                                                let type = DictionaryMissingElementTypes.error;
                                                if (props.additionalDicts.hasOwnProperty(field.dict)) {
                                                    let idFieldProperty = field.idField ? field.idField : "_id";
                                                    let dictEl = _.find(props.additionalDicts[field.dict], (dictElement) => {
                                                        if (typeof dictElement[idFieldProperty] == 'object') {
                                                            let dictElementOID = dictElement[idFieldProperty];
                                                            if (dictElementOID && dictElementOID.hasOwnProperty("$oid")) {
                                                                return dictElementOID["$oid"] == nestedId["$oid"];
                                                            }
                                                        }
                                                    });
                                                    if (dictEl) {
                                                        let fieldMainDisplay = field.dictDisplayField ? field.dictDisplayField : "_id";
                                                        let display = dictEl[fieldMainDisplay];
                                                        if (field.dictDisplayFieldCode) {
                                                            display += ` (${getStringValue(dictEl, field.dictDisplayFieldCode, ", ")})`;
                                                        }
                                                        return (
                                                            <td>
                                                                <div className={classes.dictRepresentation}>
                                                                    {display}
                                                                </div>
                                                            </td>
                                                        )
                                                    } else {
                                                        missingText = t("It item");
                                                        missingText += " " + nestedId["$oid"] + " ";
                                                        missingText += t("does not exits in the");
                                                        missingText += " " + field.dict + " ";
                                                        missingText += t("dictionary") + ".";
                                                        type = DictionaryMissingElementTypes.warning;
                                                    }
                                                }
                                                return (
                                                    <td>
                                                        <DictionaryMissingElementTableRenderer type={type}
                                                                                               missingText={missingText}>
                                                            {nestedId["$oid"]}
                                                        </DictionaryMissingElementTableRenderer>
                                                    </td>
                                                )
                                            } else {
                                                return (<td></td>)
                                            }
                                        } else {
                                            dispatch(setSnackbar({
                                                type: "warning",
                                                message: t("Column") + " [" + field.display + "] " + t("is 'dictionary' type but no dict configured") + "!",
                                            }));
                                            return (
                                                <td>
                                                    {JSON.stringify(_.get(rowData, field.id))}
                                                </td>
                                            )
                                        }
                                    case "search":
                                        let nestedCode = _.get(rowData, field.id);
                                        if (field.hasOwnProperty('dict')) {
                                            if (nestedCode != null && nestedCode.length > 0) {
                                                let missingText = t("Incorrect configuration, missing dependency table dictionary!");
                                                let type = DictionaryMissingElementTypes.error;
                                                if (props.additionalDicts.hasOwnProperty(field.dict)) {
                                                    let idFieldProperty = field.idField ? field.idField : "_id";
                                                    let dictEl = _.find(props.additionalDicts[field.dict], [idFieldProperty, nestedCode]);
                                                    if (dictEl) {
                                                        let fieldMainDisplay = field.dictDisplayField ? field.dictDisplayField : "_id";
                                                        let display = dictEl[fieldMainDisplay];
                                                        if (field.dictDisplayFieldCode) {
                                                            display += ` (${getStringValue(dictEl, field.dictDisplayFieldCode, ", ")})`;
                                                        }
                                                        return (
                                                            <td>
                                                                <div className={classes.dictRepresentation}>
                                                                    {display}
                                                                </div>
                                                            </td>
                                                        )
                                                    } else {
                                                        missingText = t("It item");
                                                        missingText += " " + nestedCode + " ";
                                                        missingText += t("does not exits in the");
                                                        missingText += " " + field.dict + " ";
                                                        missingText += t("dictionary") + ".";
                                                        type = DictionaryMissingElementTypes.warning;
                                                    }
                                                }
                                                return (
                                                    <td>
                                                        <DictionaryMissingElementTableRenderer type={type}
                                                                                               missingText={missingText}>
                                                            {nestedCode}
                                                        </DictionaryMissingElementTableRenderer>
                                                    </td>
                                                )
                                            } else {
                                                return (<td></td>)
                                            }
                                        } else {
                                            dispatch(setSnackbar({
                                                type: "warning",
                                                message: t("Column") + " [" + field.display + "] " + t("is 'search' type but no dict configured") + "!",
                                            }));
                                            return (
                                                <td>
                                                    {rowData[field.id]}
                                                </td>
                                            )
                                        }
                                    case "specialties": // dict element!
                                    case "stringList":
                                        const empty = "-" + t('empty') + "-";
                                        let display = empty;
                                        let value = "";
                                        if (_.get(rowData, field.id) != null) {
                                            if (Array.isArray(_.get(rowData, field.id)) && _.get(rowData, field.id).length > 0) {
                                                value = _.get(rowData, field.id).join(",");
                                            } else {
                                                value = JSON.stringify(_.get(rowData, field.id));
                                                if (value) {
                                                    value = value.replaceAll("\"", "");
                                                }
                                            }
                                            display = value;
                                        }
                                        return (
                                            <td><Tooltip title={value} className={classes.objectIcon}>
                                                <Chip icon={value != "" ? <DataArrayIcon/> : (<span/>)}
                                                      label={display}
                                                      variant="outlined"
                                                      onClick={() => {
                                                          if (display != empty) handleCopyToClipboard(value)
                                                      }}/>
                                            </Tooltip></td>
                                        )
                                    case "numberList": {
                                        const empty = "-" + t('empty') + "-";
                                        let display = empty;
                                        let value = "";
                                        if (_.get(rowData, field.id) != null) {
                                            if (Array.isArray(_.get(rowData, field.id)) && _.get(rowData, field.id).length > 0) {
                                                let numbers = [];
                                                _.get(rowData, field.id).forEach(item => {
                                                    if (item.hasOwnProperty('$numberInt')) {
                                                        numbers.push(item['$numberInt']);
                                                    }
                                                })
                                                value = numbers.join(",");
                                            } else {
                                                value = JSON.stringify(_.get(rowData, field.id));
                                                if (value) {
                                                    value = value.replaceAll("\"", "");
                                                }
                                            }
                                            display = value;
                                        }
                                        return (
                                            <td><Tooltip title={value} className={classes.objectIcon}>
                                                <Chip icon={value != "" ? <DataArrayIcon/> : (<span/>)}
                                                      label={display}
                                                      variant="outlined"
                                                      onClick={() => {
                                                          if (display != empty) handleCopyToClipboard(value)
                                                      }}/>
                                            </Tooltip></td>
                                        )
                                    }
                                    case "objectList": {
                                        const empty = "-" + t('empty') + "-";
                                        let display = empty;
                                        let value = "";
                                        if (_.get(rowData, field.id) != null) {
                                            if (Array.isArray(_.get(rowData, field.id)) && _.get(rowData, field.id).length > 0 && field.hasOwnProperty("fields")) {
                                                let items = [];
                                                _.get(rowData, field.id).forEach(item => {
                                                    let newItemEl = {};
                                                    Object.keys(field['fields']).forEach(key => {
                                                        if (typeof item[key] == 'object') {
                                                            Object.keys(item[key]).forEach(nestedKey => {
                                                                switch (nestedKey) {
                                                                    case "$numberInt":
                                                                    case "$numberDouble" :
                                                                    case "$numberLong" :
                                                                    case "$oid": {
                                                                        newItemEl[key] = item[key][nestedKey];
                                                                        break;
                                                                    }
                                                                    default: {
                                                                        console.log("unrecognized key type " + nestedKey);
                                                                        newItemEl[key] = JSON.stringify(item[key][nestedKey]);
                                                                    }
                                                                }
                                                            })
                                                        } else {
                                                            newItemEl[key] = item[key];
                                                        }
                                                    })
                                                    items.push(JSON.stringify(newItemEl).replaceAll("\"", ""));
                                                })
                                                value = "[" + items.join(",") + "]";
                                            } else {
                                                value = JSON.stringify(_.get(rowData, field.id));
                                                if (value) {
                                                    value = value.replaceAll("\"", "");
                                                }
                                            }
                                            display = value;
                                        }
                                        return (
                                            <td>
                                                <Tooltip title={value} className={classes.objectIcon}>
                                                    <Chip icon={value != "" ? <DataArrayIcon/> : (<span/>)}
                                                          label={display}
                                                          variant="outlined"
                                                          onClick={() => {
                                                              if (display != empty) handleCopyToClipboard(value)
                                                          }}/>
                                                </Tooltip>
                                            </td>
                                        )
                                    }
                                    case "searchList":
                                    case "dividedSearchList":
                                        let fieldId = fieldType == "dividedSearchList" ? field.divided.baseFieldId : field.id
                                        if (_.get(rowData, fieldId) != null && Array.isArray(_.get(rowData, fieldId)) && _.get(rowData, fieldId).length > 0) {
                                            if (field.hasOwnProperty('dict') && props.additionalDicts.hasOwnProperty(field.dict)) {
                                                //max shows items
                                                let arrayOfItemsDisplay = prepareDictArrayNames(_.get(rowData, fieldId), field, props.additionalDicts[field.dict], fieldType != "dividedSearchList");
                                                return (
                                                    <td><Tooltip title={arrayOfItemsDisplay.join(",")}
                                                                 className={classes.objectIcon}>
                                                        <Chip icon={<DataArrayIcon/>}
                                                              label={arrayOfItemsDisplay.join(",")}
                                                              variant="outlined"
                                                            // style={{maxWidth: "180px"}}
                                                              onClick={() => handleCopyToClipboard(JSON.stringify(arrayOfItemsDisplay))}/>
                                                    </Tooltip></td>
                                                )
                                            } else {
                                                <td>{t("Wrong configuration")}</td>
                                                //no dict configured
                                            }
                                        } else {
                                            const empty = "-" + t('empty') + "-";
                                            return (
                                                <td><Tooltip title={"[]"} className={classes.objectIcon}>
                                                    <Chip icon={<DataArrayIcon/>}
                                                          label={empty}
                                                          variant="outlined"/>
                                                </Tooltip></td>
                                            )
                                        }
                                    case "colorListSelect":
                                    case "color": {
                                        return (<td>
                                            <Tooltip title={_.get(rowData, field.id)}
                                                     className={classes.objectIcon}>
                                                <div className={classes.colorPickerDisplay}
                                                     style={{background: _.get(rowData, field.id)}}></div>
                                            </Tooltip>
                                        </td>)
                                    }
                                    case "dictionaryList":
                                    case "multiDict":
                                    default:
                                        return (
                                            <td>
                                                -{t('empty')}-
                                            </td>
                                        )
                                }
                            } else {
                                return (
                                    <td className={classes.empty}></td>
                                )
                            }
                        },
                        headerRenderer: ({columnIndex, column, className}) => {
                            //console.log("headerRenderer 1 ",columnIndex, column, className);
                            return (
                                <th className={field.type == "boolean" ? classes.colBoolean : null}
                                    style={{minWidth: column.width}}>
                                    {column.prefix}{column.name}
                                </th>
                            )
                        },
                        width: field.width ? field.width : 1,
                        name: field.display ? field.display : "...",
                        prefix: field.divided && field.divided.prefix ? field.divided.prefix + " " : ""
                    })
                }
            });
            //actions on table right end
            fieldsColumns.push({
                cellRenderer: ({ columnIndex, column, rowData, rowIndex, className }) => {
                    //console.log("cell renderer 2 " + columnIndex, column);
                    if(rowData.hasOwnProperty(props.idField)) {
                        return (
                            <td className={classes.actionsColRecord}>
                                {rowData.hasOwnProperty("technical") && rowData.technical == true &&
                                <Tooltip title={t("Technical record. NOT EDITABLE")} enterDelay={500} enterTouchDelay={500} enterNextDelay={500}>
                                    <Button variant="outlined"
                                            className={clsx(classes.actionBtn, classes.btnConfigFields, classes.info)}
                                            onClick={() => {
                                                dispatch(setSnackbar({
                                                    type: "info",
                                                    message: t("Technical field. Can't be edited"),
                                                }));
                                            }}>
                                        <span className={classes.icon}>T</span>
                                    </Button>
                                </Tooltip>
                                }
                                {(!rowData.hasOwnProperty("technical")  || (rowData.hasOwnProperty("technical") && (rowData.technical == false || rowData.technical == null))) &&
                                <Tooltip title={t("Edit")} enterDelay={500} enterTouchDelay={500} enterNextDelay={500}>
                                    <Button variant="outlined"
                                            className={clsx(classes.actionBtn, classes.btnConfigFields, classes.edit)}
                                            onClick={() => {
                                                editRow(rowData, rowIndex)
                                            }}
                                            disabled={idsBlockedForEdit.indexOf(rowData[props.idField]) > -1}>
                                        <AgyleNamedIcon name="editPencil" className={classes.icon}/>
                                    </Button>
                                </Tooltip>
                                }
                                <Tooltip title={t("Delete")} enterDelay={500} enterTouchDelay={500} enterNextDelay={500}>
                                    <Button variant="outlined"
                                            className={clsx(classes.actionBtn, classes.btnConfigFields, classes.delete)}
                                            onClick={() => {
                                                deleteRow(rowData, rowIndex)
                                            }}
                                            disabled={idsBlockedForEdit.indexOf(rowData[props.idField]) > -1}>
                                        <AgyleNamedIcon name="trashBin" className={classes.icon}/>
                                    </Button>
                                </Tooltip>

                                {(props.mergeEndpoint==null && (props.additionalFunctions== null || (props.additionalFunctions.indexOf("showAvailableIn") == -1) && props.additionalFunctions.indexOf("manageConsultantAvailableIn") == -1)) &&
                                <Tooltip title={t("JSON view")} enterDelay={500} enterTouchDelay={500} enterNextDelay={500}>
                                    <Button variant="outlined"
                                            className={clsx(classes.actionBtn, classes.btnConfigFields, classes.viewJson)}
                                            onClick={() => {
                                                openEditJsonDialog(rowData)
                                            }}>
                                        <InfoOutlinedIcon className={classes.icon}/>
                                    </Button>
                                </Tooltip>
                                }
                                {/*else*/}
                                {(props.mergeEndpoint!=null || (props.additionalFunctions!= null && (props.additionalFunctions.indexOf("showAvailableIn") > -1 || props.additionalFunctions.indexOf("manageConsultantAvailableIn") > -1))) &&
                                <Tooltip title={t("more")} enterDelay={500} enterTouchDelay={500} enterNextDelay={500}>
                                    <Button variant="outlined"
                                            className={clsx(classes.actionBtn, classes.btnConfigFields, classes.viewJson)}
                                            onClick={(event) => {
                                                handleClickRowActionMenu(event,rowData)
                                            }}>
                                        <AgyleNamedIcon name="bmTable" className={classes.icon}/>
                                    </Button>
                                </Tooltip>
                                }
                            </td>
                        )
                    } else {
                        return null;
                    }
                },
                headerRenderer: ({ columnIndex, column, className }) => {
                   //console.log("headerRenderer 2 ",columnIndex, column, className);
                   return(
                   // <th className={(props.mergeEndpoint ? classes.actionsColMerge : classes.actionsCol)}>
                   <th className={classes.actionsCol}>
                       {t("Actions")}
                       {/*<Button variant="outlined" className={clsx(classes.actionBtn, classes.actionsColBtn)}*/}
                       {/*        onClick={()=>{setOrderColumnsOpen(true)}}>*/}
                       {/*    <AgyleNamedIcon name="dbSlices" className={classes.icon}/>*/}
                       {/*</Button>*/}
                   </th>)
               },
                width: 100,
                name: "actions"
            });
            setColumns(fieldsColumns);
            //setFields(props.fields);
        }
        //setInfinityScrollEdge(props.pageSize ? props.pageSize : 100);
    }, [props.fields, props.pageSize, props.idField, idsBlockedForEdit, props.masterRecordId, props.mergeEnpoint, props.additionalDicts]);
    
    React.useEffect(()=> {
        if (props.additionalDicts && props.additionalDicts.hasOwnProperty("rolesFilter") &&
            JSON.stringify(props.additionalDicts["rolesFilter"]) != JSON.stringify(filterConsultant.rolesDictItemsAll)) {
            let fc = _.cloneDeep(filterConsultant);
            fc.rolesDictItemsAll = _.cloneDeep(props.additionalDicts["rolesFilter"]);
            fc.rolesDictItems = _.cloneDeep(props.additionalDicts["rolesFilter"]);
            _.forEach(props.additionalDicts["rolesFilter"], item => {
                fc.rolesColorIconMap[item._id] = {"name": item.description};
                if (item.color) {
                    item.type = "coloredOption";
                    item.color = item.color;
                    fc.rolesColorIconMap[item._id]['color'] = item.color;
                } else {
                    fc.rolesColorIconMap[item._id]['color'] = "rgba(255,255,255,0)";
                }
                if (item.icon) {
                    //should be checked is icon correct name ???
                    item.icon = item.icon;
                    fc.rolesColorIconMap[item._id]['icon'] = item.icon;
                }
            });
            setFilterConsultant(fc);
        }
    }, [props.additionalDicts.rolesFilter])

    React.useEffect(()=>{
        if(props.fieldsData && props.fields.length >= 0){
            //analise previous set order and visibility per user!!
            if(props.fieldsData.length == 1){
                setFieldsData([{},...props.fieldsData]);
            } else {
                setFieldsData([...props.fieldsData]);
            }
            _.forEach(props.fieldsData, (rowData) => {
                if(rowData.hasOwnProperty("technical") && rowData.technical){
                    setIdsBlockedForEdit([...idsBlockedForEdit, rowData[props.idField]]);
                }
            })
        }
        else {
            setFieldsData([]);
        }
    }, [props.fieldsData]);

    React.useEffect(()=> {
        if(message){
            try {
                const msg = message;
                if(msg.data && msg.data.action){
                    const id = msg.data.record[props.idField];
                    switch(msg.data.action) {
                        case "openToEdit":
                        case "editing":
                            if(idsBlockedForEdit.indexOf(id) < 0)
                                setIdsBlockedForEdit([...idsBlockedForEdit, id]);
                            break;
                        case "closeEdit":
                        case "modified":
                        case "addNew":
                        case "delete":
                            if(idsBlockedForEdit.indexOf(id) > -1){
                                let idsArr = [...idsBlockedForEdit];
                                idsArr.splice(idsArr.indexOf(id),1);
                                setIdsBlockedForEdit(idsArr);
                            }
                            break;
                        default:
                            console.log("some message received: ", msg);
                    }
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }, [message])

    React.useEffect(()=> {
        setTimeout(()=>{
            setWebSocketChanel(props.webSocketChanel);
            setRunSocket(true);
        }, 1);
        return ()=>{
            setRunSocket(false);
        }
    }, [props.webSocketChanel])

    //filter needs to check prepared all data!!! and set slice for

    const openEditJsonDialog = (rowData) => {
       setViewRowItem(rowData);
       setViewRowItemOpen(true);
       setEditObjectJson(JSON.stringify(rowData, undefined, 4));
    }

    const openConsultantAvailableInPickers = (rowData, dialog) => {
        setViewRowItem(rowData);
        switch(dialog){
            case "showAvailableIn":
                setViewConsultantAvailableInPickerOpen(true);
                break;
            case "manageConsultantAvailableIn":
                let fc = _.cloneDeep(filterConsultant);
                fc.text = "";
                fc.roles = [];
                fc.rolesIds = [];
                fc.isFiltering = false;
                fc.keepSelected = false;
                fc.consultantsActive = [];
                fc.consultantsNotActive = [];
                fc.rolesDictItems = _.cloneDeep(fc.rolesDictItemsAll);
                let conAll = [];
                if(props.additionalDicts.hasOwnProperty("consultants")){
                    const rolesFields = _.get(props.filterHelper, "rolesFilter", []);
                    props.additionalDicts.consultants.map((cnls, lp) => {
                        let cnl = _.cloneDeep(cnls);
                        if(typeof cnl._id == "object"){
                            if(cnl._id.hasOwnProperty("$oid")) {
                                cnl.id = cnl._id['$oid'];
                            } else {
                                cnl.id = JSON.stringify(cnl._id).replaceAll(" ", "_");
                            }
                        } else {
                            cnl.id = cnl._id;
                        }
                        cnl.mapRoles = [];
                        _.forEach(rolesFields, (roleField) => {
                            let fieldValue = _.get(cnls, roleField, []);
                            if (!Array.isArray(fieldValue)) fieldValue = [fieldValue];
                            _.forEach(fieldValue, (roleId) => {
                                cnl.mapRoles.push(_.cloneDeep(fc.rolesColorIconMap[roleId]));
                            })
                        })
                        conAll.push(cnl);
                    })
                    setAllConsultants(conAll);
                    let consultantsArr = _separateConsultantsActiveNonActive(conAll,  rowData);
                    fc.consultantsActive = consultantsArr[0];
                    fc.consultantsNotActive = consultantsArr[1];
                }
                setFilterConsultant(fc);
                setPickedToMove({off: [],on: []});
                setManageAvailableInPickersOpen(true);
                break;
        }
    }

    const _separateConsultantsActiveNonActive = (consultantsSet, recordItem) => {
        let active = [...(_.cloneDeep(consultantsSet))];
        let nonActive = [...(_.remove(active, (c) => !c.hasOwnProperty("availableIn") || c.availableIn.indexOf(recordItem._id) == -1))];
        return [active, nonActive]
    }

    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then((result) => {
            dispatch(setSnackbar({type: "info", message: t("Copied to clipboard")}));
        });
    }

    const handleCloseDialogOrderColumnsOpen = () => {
        setOrderColumnsOpen(false);
    }

    const handleSaveOrderColumns = () => {
        setOrderColumnsOpen(false);
    }

    const editRow = (rowData, tabIndex = undefined) => {
        props.rowAction("edit", rowData, tabIndex);
    }
    const mergeRow = (rowData, tabIndex = undefined) => {
        props.rowAction("merge", rowData, tabIndex);
    }
    const deleteRow = (rowData, tabIndex = undefined) => {
        props.rowAction("delete", rowData, tabIndex);
    }

    const handleCloseDialogViewRowItemOpen = () => {
        setViewRowItem(null);
        setViewRowItemOpen(false);
    }

    const handleCloseDialogConsultantAvailableInPickerOpen = () => {
        setViewRowItem(null);
        setViewConsultantAvailableInPickerOpen(false);
    }

    const handleCloseDialogManageAvailableOpen = () => {
        setViewRowItem(null);
        setManageAvailableInPickersOpen(false);
    }

    const fetchMoreData = () => {
        console.log("fetch more data!!!");
        if(!props.haveAllDataPages) {
            setInfinityLoading(true);
            props.getMoreRecordsHandler(undefined, undefined, undefined, undefined, (new AbortController()).signal, false).then((results) => {
                setFieldsData([...results]);
                setInfinityLoading(false);
            });
        }
    }

    const handleSaveJSONData = (jsonData) => {
        if(props.saveEditedJSON){
            try {
                let jsonValue = JSON.parse(jsonData);
                props.saveEditedJSON(jsonValue);
            } catch (ex) {
                dispatch(setSnackbar({type: "error", message: t("Error in JSON.")  + ex}));
            }
        }
        handleCloseDialogViewRowItemOpen();
    }

    const getPickedDictionaryOptions = (additionalDictionaryName, baseFieldId, activeRecord) => {
        let items = [];
        if(props.additionalDicts.hasOwnProperty(additionalDictionaryName)) {
            props.additionalDicts[additionalDictionaryName].forEach(additionalDictItem => {
                if (!additionalDictItem.technical) {
                    if(activeRecord && !activeRecord[baseFieldId]) activeRecord[baseFieldId] = [];
                    items.push((<tr key={additionalDictionaryName + "_" + additionalDictItem._id} sx={{display:"inline-flex"}}>
                        <td>
                            {activeRecord &&
                            <AgyleCheckBox className="inline"
                                           value={activeRecord[baseFieldId].indexOf(additionalDictItem._id) > -1}
                                           disabled={(props.saveEditedJSON == null || idsBlockedForEdit.indexOf(activeRecord._id) > -1)}
                                           onChange={(event) => {
                                               let activeRecordCopy = _cloneDeep(activeRecord);
                                               if(event.target.checked) {
                                                   if(activeRecordCopy[baseFieldId].indexOf(additionalDictItem._id) == -1){
                                                       activeRecordCopy[baseFieldId].push(additionalDictItem._id);
                                                   }
                                               } else {
                                                   _.remove(activeRecordCopy[baseFieldId], (item) => item == additionalDictItem._id);
                                               }
                                               props.saveEditedJSON(activeRecordCopy);
                                               setViewRowItem(activeRecordCopy);
                                           }}>
                            </AgyleCheckBox>
                            }
                        </td>
                        <td>

                            {additionalDictItem.description}

                        </td>
                        <td>
                            {additionalDictItem.specification}
                        </td>
                    </tr>))
                }
            })
        }
        return (items)
    }

    const renderEndAdornment = () => {
        return (
            <>
                {loading &&
                <CircularProgress style={{color: '#fff'}} size={20}/>
                }

                {(!loading) &&
                <InputAdornment position="end">
                    <IconButton onClick={() => { textFilterChange(""); }}><CloseIcon/></IconButton>
                </InputAdornment>
                }
            </>
        );
    };

    return (

        <React.Fragment>
            <Table
                className={classes.dictTable}
                tableClassName='table table-bordered table-striped' // example using bootstrap
                height={window.innerHeight - 155}
                rowHeight={40}
                rows={props.loading || rerender ? [] : fieldsData}
                columns={columns}
                headerCount={1}
                footerCount={0}
                fillTableWidth={false}
                rowIdKey='id'
                noRowsRenderer={() => {
                    if(props.loading) {
                        return (<span>{t("Loading")} <CircularProgress /> </span>);
                    } else {
                        return (<span>{t("Selected dict") + " " + props.dictName + " " + t("is empty") + "."}</span>);
                    }
                }}
                // keep the first column fixed:
                fixedColumnsCount={0}
                // row selection
                  //selectedRows={this.state.selectedRows}
                  //onSelectionChange={selectedRows => { this.setState({selectedRows}) }}
                  //canSelectMultipleRows={true|false}
                // infinite load:
                infiniteLoadBeginEdgeOffset={infinityScrollEdge}
                isInfiniteLoading={infinityLoading}
                onInfiniteLoad={fetchMoreData}
                getLoadingSpinner={() => <div>{t("Loading")} <CircularProgress /> </div>}
                // display from bottom upwards, like a Chat or Message Box
                //displayBottomUpwards={displayBottomUpwards}
                // allows column resize
                onColumnWidthChange={(columnIndex, width) => { /* update columns... */ }}
                // allows column reorder (by dragging)
                onColumnOrderChange={(fromIndex, toIndex) => { /* update columns... */ }}
            />
            <Popper
                anchorEl={rowAnchorEl}
                id={"action-menu"}
                open={openRowActionMenu}
                // onClose={handleCloseActionMenu}
                // onClick={handleCloseActionMenu}
                placement="left"
                className={classes.moreActionPopper}
                disablePortal
            >
                <Box className={classes.moreActionsBox}>
                    <ClickAwayListener onClickAway={handleCloseActionMenu}>
                        <ul>
                            <li onClick={(event) => {
                                handleCloseActionMenu(event);
                                openEditJsonDialog(rowAffectedMenu);
                            }}>
                                <div>
                                    <InfoOutlinedIcon className={classes.icon}/>
                                    {t("JSON view")}
                                </div>
                            </li>
                            {props.mergeEndpoint != null &&
                            <li onClick={(event) => {
                                handleCloseActionMenu(event);
                                mergeRow(rowAffectedMenu);
                            }}>
                                <div>
                                    <AgyleNamedIcon name="recordMerges" className={classes.icon}/>
                                    {t("Merge Consultant")}
                                </div>
                            </li>
                            }
                            {props.additionalFunctions!= null && props.additionalFunctions.indexOf("showAvailableIn") > -1 &&
                            <li onClick={(event) => {
                                handleCloseActionMenu(event);
                                openConsultantAvailableInPickers(rowAffectedMenu, "showAvailableIn");
                            }}>
                                <div>
                                    <AgyleNamedIcon name="checklist" className={classes.icon}/>
                                    {t("Show accessibility consultant picker")}
                                </div>
                            </li>
                            }
                            {props.additionalFunctions!= null && props.additionalFunctions.indexOf("manageConsultantAvailableIn") > -1 &&
                            <li onClick={(event) => {
                                handleCloseActionMenu(event);
                                openConsultantAvailableInPickers(rowAffectedMenu, "manageConsultantAvailableIn");
                            }}>
                                <div>
                                    <AgyleNamedIcon name="checklist" className={classes.icon}/>
                                    {t("Show accessibility consultant picker")}
                                </div>
                            </li>
                            }
                        </ul>
                    </ClickAwayListener>
                </Box>
            </Popper>
            <Dialog open={orderColumnsOpen} onClose={handleCloseDialogOrderColumnsOpen}>
                <DialogTitle>
                    {t("Order columns")}
                </DialogTitle>
                <DialogContent>
                    {fields && fields.map((itemField) => (
                        <div key={"order_columns_" + itemField.display}>{itemField.beTranslate ? t(itemField.display) : itemField.display}</div>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCloseDialogOrderColumnsOpen}>
                        {t("Cancel")}
                    </Button>
                    <Button onClick={handleSaveOrderColumns}>
                        {t("Save")}
                    </Button>
                </DialogActions>
            </Dialog>
            <AgyleDialog
                title={t("Row item")}
                open={viewRowItemOpen}
                onClose={handleCloseDialogViewRowItemOpen}
                width={"lg"}
                fullWidth
                disableSave={true}
                buttons={
                    [<Button onClick={(ev) => {handleCopyToClipboard(editObjectJson)}}>
                        {t("Copy to clipboard")}
                    </Button>,
                    <Button onClick={() => {handleSaveJSONData(editObjectJson)}}
                            disabled={(props.saveEditedJSON == null) ||
                                      (viewRowItem && viewRowItem.hasOwnProperty(props.idField) && idsBlockedForEdit.indexOf(viewRowItem[props.idField])>-1)}>
                {t("Update data")}
                    </Button>]
                }
            >
                <TextareaAutosize maxRows={30} minRows={3} placeholder="Empty"  style={{width: "100%"}}
                                  defaultValue={editObjectJson}
                                  onChange={(event) => {setEditObjectJson(event.target.value)}}></TextareaAutosize>
            </AgyleDialog>
            <AgyleDialog
                title={t("Consultant available inside picker")}
                open={viewConsultantAvailableInPickerOpen}
                onClose={handleCloseDialogConsultantAvailableInPickerOpen}
                width={"lg"}
                fullWidth
                disableSave={true}
                buttons={[]}
            >
                <Grid container>
                    <Grid item xs={7} className={classes.consultantName}>
                        {_.get(viewRowItem, "title")}&nbsp;
                        {getConsultantName(viewRowItem)}&nbsp;
                        <span className={classes.uppercase}>({_.get(viewRowItem, "jobTitle")})</span>
                    </Grid>
                    <Grid item xs={3}>
                        {getConsultantCode(viewRowItem)}
                    </Grid>
                    <Grid item xs={2}>
                        {_.get(viewRowItem, "consultantType")}
                    </Grid>
                    <Grid item xs={12}>
                        {props.dividedMap && props.dividedMap["showAvailableIn"] && props.additionalDicts && props.dividedMap["showAvailableIn"].map((dMapItem) => {
                            return (
                                <AgyleAccordion key={"accordion_" + dMapItem.dictName + "_" + dMapItem.baseFieldId}
                                    expanded={expanded[dMapItem.dictName]}
                                    onChange={() => {
                                        let exp = _cloneDeep(expanded);
                                        if(!exp.hasOwnProperty(dMapItem.dictName)){
                                            exp[dMapItem.dictName] = true;
                                        } else {
                                            exp[dMapItem.dictName] = !exp[dMapItem.dictName];
                                        }
                                        setExpanded(exp)}
                                    }
                                    label={t(dMapItem.listName)}
                                >
                                    <table>
                                        <tbody>
                                            {getPickedDictionaryOptions(dMapItem.dictName, dMapItem.baseFieldId, viewRowItem)}
                                        </tbody>
                                    </table>
                                </AgyleAccordion>
                            )
                        })}
                    </Grid>
                </Grid>
            </AgyleDialog>
            <AgyleDialog
                title={t("Manage consultants access to current picker")}
                open={viewManageAvailableInPickersOpen}
                onClose={handleCloseDialogManageAvailableOpen}
                width={"lg"}
                fullWidth
                disableSave={true}
                buttons={[]}
                disableActionsCloseButton={loading}
            >
                <Grid container>
                    <Grid item xs={12} className={classes.pickerDesc}>
                        <div>
                        {_.get(viewRowItem, "description", 'NO DESCRIPTION')}
                        </div>
                        {(_.get(viewRowItem, "specification")) &&
                            <div className={classes.pickerSpec}>
                                <Tooltip title={_.get(viewRowItem, "specification", 'NO SPECIFICATION')}>
                                    <HelpOutlineIcon/>
                                </Tooltip>
                            </div>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.filterSection}>
                            <div className={classes.filterGroup}>
                                <div className={classes.filterItem}>
                                    <AgyleTextField
                                        className={classes.inputFilter}
                                        debounce
                                        // label={t("Consultant name or code")}
                                        name="consultantFilterText"
                                        placeholder={t("Consultant name or code")}
                                        value={filterConsultant.text}
                                        onChange={(ev) => {textFilterChange(ev.target.value)}}
                                        fullWidth
                                        endAdornment={renderEndAdornment()}
                                        disabled={filterConsultant.isFiltering || loading}
                                    />
                                    {/*<TextField*/}
                                    {/*    className={classes.inputFilter}*/}
                                    {/*    name="consultantFilterText"*/}
                                    {/*    fullWidth*/}
                                    {/*    variant="outlined"*/}
                                    {/*    placeholder={t("Consultant name or code")}*/}
                                    {/*    InputProps={{*/}
                                    {/*        endAdornment: filterConsultant.text.length > 0 ? (<IconButton onClick={() => {*/}
                                    {/*            textFilterChange("");*/}
                                    {/*        }}><CloseIcon/></IconButton>) : <span></span>*/}
                                    {/*    }}*/}
                                    {/*    onChange={(ev) => {textFilterChange(ev.target.value)}}*/}
                                    {/*    value={filterConsultant.text}*/}
                                    {/*    autoComplete="false"*/}
                                    {/*    disabled={filterConsultant.isFiltering || loading}*/}
                                    {/*/>*/}
                                </div>
                                <div className={classes.filterItem}>
                                    <Autocomplete
                                        className={classes.rolesSelectField}
                                        limitTags={3}
                                        multiple
                                        disablePortal
                                        disableClearable
                                        clearOnEscape={true}
                                        value={filterConsultant.roles}
                                        options={filterConsultant.rolesDictItems}
                                        getOptionLabel={(option) => option.description || "!!!"}
                                        renderInput={(params) => <TextField {...params} label={t("Roles")} />}
                                        renderOption={(props, option) => renderCustomOption(option)}
                                        renderTags={renderValue}
                                        disabled={filterConsultant.isFiltering || loading}
                                    />
                                </div>
                                <AgyleButton
                                    size="medium"
                                    className={clsx(classes.buttonFilter)}
                                    onClick={filterConsultants}
                                    startIcon={<FilterAltIcon/>}
                                    disabled={filterConsultant.isFiltering || loading}
                                >
                                    {t("Filter")}
                                </AgyleButton>
                            </div>
                            <div>

                            </div>
                            <div className={classes.keepSelected}>
                                <AgyleSwitch
                                    label={t('Keep selected')}
                                    disabled={filterConsultant.isFiltering || loading}
                                    onChange={keepSelectedChange}
                                    value={filterConsultant.keepSelected}
                                    labelPlacement="start"
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} className={classes.sideBySidePanel}>
                        <div className={clsx(classes.consultantPanel,classes.unusedConsultants)}>
                            {loading && <AgyleLoadingSpinner/>}
                            {!loading && filterConsultant.consultantsNotActive && filterConsultant.consultantsNotActive.map( (cnnu, key) =>
                                (<div key={'cnnu_' + cnnu.id + "_" + key} className={clsx(classes.consultantItem, pickedToMove['on'].indexOf(cnnu['_id']) > -1 && classes.pickedToMove)} onClick={() => pickToMove(cnnu['_id'], 'on')}>
                                    <span>{cnnu['id']}</span>
                                    <span className={classes.consultantName}>{cnnu['firstName']} {cnnu['familyName']}</span>
                                    {cnnu['pasCode'] && cnnu['pasCode'].length > 0 &&<span className={classes.consultantCode}>[{cnnu['pasCode']}] </span> }
                                    {cnnu.mapRoles && cnnu.mapRoles.map((role, idxKey) => (
                                        <div className={classes.squareMarker} key={idxKey}
                                             style={{backgroundColor:role && role.hasOwnProperty('color') ? role.color : '#FFFFFF'}}
                                             title={role && role.hasOwnProperty('name') ? role.name : ''}></div>
                                    ))}
                                </div>)
                            )}
                        </div>
                        <div className={classes.toolPanel}>
                            <br/>
                            <div>
                                <AgyleButton
                                    size="small"
                                    className={classes.button}
                                    onClick={() => {
                                        moveToOtherSide(1);
                                    }}
                                    disabled={pickedToMove.on.length == 0 || loading}
                                >
                                    <KeyboardArrowRightIcon/>
                                </AgyleButton>
                            </div>
                            <div>
                                <AgyleButton
                                    size="small"
                                    className={classes.button}
                                    onClick={() => {
                                        confirmMoveAll("allToOn");
                                    }}
                                    disabled={loading}
                                >
                                    <KeyboardDoubleArrowRightIcon/>
                                </AgyleButton>
                            </div>
                            <br/>
                            <br/>
                            <br/>
                            <div>
                                <AgyleButton
                                    size="small"
                                    className={classes.button}
                                    onClick={() => {
                                        moveToOtherSide(-1);
                                    }}
                                    disabled={pickedToMove.off.length == 0 || loading}
                                >
                                    <KeyboardArrowLeftIcon/>
                                </AgyleButton>
                            </div>
                            <div>
                                <AgyleButton
                                    size="small"
                                    className={classes.button}
                                    onClick={() => {
                                        confirmMoveAll("allToOff");
                                    }}
                                    disabled={loading}
                                >
                                    <KeyboardDoubleArrowLeftIcon/>
                                </AgyleButton>
                            </div>
                            <br/>
                        </div>
                        <div className={clsx(classes.consultantPanel,classes.usedConsultants)}>
                            {loading && <AgyleLoadingSpinner/>}
                            {!loading && filterConsultant.consultantsActive && filterConsultant.consultantsActive.map( (cnu, key) =>
                                (<div key={'cnu_' + cnu.id + "_"  + key} className={clsx(classes.consultantItem, pickedToMove['off'].indexOf(cnu['_id']) > -1 && classes.pickedToMove)} onClick={() => pickToMove(cnu['_id'], 'off')}>
                                    <span>{cnu['id']}</span>
                                    <span className={classes.consultantName}>{cnu['firstName']} {cnu['familyName']}</span>
                                    {cnu['pasCode'] && cnu['pasCode'].length > 0 && <span className={classes.consultantCode}>[{cnu['pasCode']}] </span> }
                                    {cnu.mapRoles && cnu.mapRoles.map((role, idxKey) => (
                                        <div className={classes.squareMarker} key={idxKey}
                                             style={{backgroundColor:role && role.hasOwnProperty('color') ? role.color : '#FFFFFF'}}
                                             title={role && role.hasOwnProperty('name') ? role.name : ''}></div>
                                    ))}
                                </div>)
                            )}
                        </div>
                    </Grid>
                </Grid>
            </AgyleDialog>
            <MessageBox
                onClose={() => setConfirmDialog(false)}
                title={t('Confirm')}
                disableSave
                disabled={false}
                message={t("Are you sure to ") + filterConsultant.confirmMessage[filterConsultant.moveAllOperationSide] + " [" + _.get(viewRowItem, "description", 'NO DESCRIPTION') + "] for " + (filterConsultant.moveAllOperationSide == 'allToOff' ? filterConsultant.consultantsActive.length : filterConsultant.consultantsNotActive.length) + " " + t('consultants') + "?" }
                haveAccept={{yes: 'Yes', no: 'No'}}
                onAccept={()=> moveAllToOtherSideAgree()}
                open={confirmDialog}
            />
        </React.Fragment>
    )
}